<template>
  <div>
    <v-data-table
      v-bind="this.$attrs"
      loading-text="Đang Tải"
      item-key="id"
      :headers="headers"
      :items="uniformes"
      :loading="loading"
      no-data-text="Không có đồng phục"
      :footer-props="{
        'items-per-page-text': 'Hiển thị mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page-options': uniformes.length > 100 ? [10, 20, 30] : [10, 20, -1],
      }"
      disable-sort
    >
      <!-- Tên loại đồng phục -->

      <template v-slot:item.name="{ item }">
        <div class="table-cell-wrapper mt-1">{{ item.name }}</div>
      </template>

      <template v-slot:item.academicLevel="{ item }">
        <div class="table-cell-wrapper mb-1 mt-1">
          <div>
            <div>{{ item.academicLevel && item.academicLevel.title || '-' }}</div>
          </div>
        </div>
      </template>

      <!-- Hình ảnh (nhiều ảnh) -->

      <template v-slot:item.images="{ item }">
        <div class="table-cell-wrapper images-wrapper mt-1">
          <template v-if="item.images && item.images.length">
            <v-img
              v-for="(img, index) in item.images.slice(0, 6)"
              :key="index"
              :src="img.url"
              class="image-preview"
              contain
              @click="openPreview(item.images, index)"
            />
          </template>

          <template v-else>
            <v-img src="/default-uniform.png" class="image-preview grey-background" contain />
          </template>
        </div>
      </template>

      <!-- Danh sách combination -->

      <template v-slot:item.uniformCombinations="{ item }">
        <div class="table-cell-wrapper">
          <div v-if="item.uniformCombinations && item.uniformCombinations.length">
            <div v-for="(comb, index) in item.uniformCombinations" :key="comb._id" class="mb-2">
              <div
                :style="{
                  color: comb.isActive ? '#000' : '#B0B0B0',
                  textDecoration: comb.isActive ? 'unset' : 'line-through',
                }"
              >
                {{ comb.optionOne && comb.optionOne.name }}{{ comb.optionTwo && ' - ' + comb.optionTwo.name
                }}{{ ' - ' + Number(comb.price).toLocaleString('vi-VN') }} (VNĐ)
              </div>

              <v-divider v-if="index < item.uniformCombinations.length - 1" class="my-1" />
            </div>
          </div>

          <div v-else>-</div>
        </div>
      </template>

      <!-- Cập nhật lần cuối bởi -->

      <template v-slot:item.updatedBy="{ item }">
        <div class="table-cell-wrapper mb-1 mt-1">
          <div>
            <div>{{ item.updatedBy && item.updatedBy.name }}</div>
            <div>{{ formatDate(item.updatedAt) }}</div>
          </div>
        </div>
      </template>

      <!-- Trạng thái hoạt động -->
      <template v-slot:item.activeStatus="{ item }">
        <div class="table-cell-wrapper mt-1">
          <v-chip :color="item.activeStatus === 'working' ? '#4CAF50' : '#FFA726'" dark label small>
            {{ item.activeStatus === 'working' ? 'Đang hoạt động' : 'Tạm dừng' }}
          </v-chip>
        </div>
      </template>

      <!-- Thao tác -->

      <template v-slot:item.actions="{ item }">
        <div class="table-cell-wrapper">
          <v-btn @click="onEdit(item)" icon><v-icon>mdi-pencil</v-icon></v-btn>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon>
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item>
                <v-list-item-title style="cursor: pointer; width: 40px" @click="onConfirmUniform(item)">
                  <v-icon>mdi-compare</v-icon>
                </v-list-item-title>
                <v-list-item-title
                  style="cursor: pointer; border-left: thin solid rgba(0, 0, 0, 0.12); padding-left: 10px"
                  @click="onRemove(item)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
    </v-data-table>

    <v-dialog v-model="previewDialog" max-width="800px">
      <v-card>
        <v-toolbar color="primary" dark dense>
          <v-toolbar-title>Xem trước ảnh</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn icon @click="previewDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-carousel v-if="previewImages.length" hide-delimiters>
          <v-carousel-item v-for="(image, idx) in previewImages" :key="idx">
            <div class="carousel-image-wrapper">
              <img :src="image.url" alt="Preview Image" class="carousel-image" />
            </div>
          </v-carousel-item>
        </v-carousel>
      </v-card>
    </v-dialog>

    <!-- Dialog xác nhận -->
    <ConfirmUniformDialog :state="confirmDialog" :uniformData="selectedItem" @updated="refresh()" />

    <UniformEditDialog :state="editDialog" :uniformData="selectedItem" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import ConfirmUniformDialog from '@/modules/uniform/ConfirmUniformDialog.vue'

const originHeaders = [
  { text: 'Tên đồng phục', value: 'name', align: 'left', sortable: false },
  { text: 'Áp dụng', value: 'academicLevel', align: 'left', sortable: false },
  { text: 'Ảnh minh hoạ', value: 'images', align: 'left', sortable: false },
  { text: 'Phân loại', value: 'uniformCombinations', align: 'left', sortable: false },
  { text: 'Trạng thái hoạt động', value: 'activeStatus', align: 'left', sortable: false },
  { text: 'Cập nhật lần cuối', value: 'updatedBy', align: 'left', sortable: false },
  { text: 'Thao tác', value: 'actions', align: 'left', sortable: false },
]

export default {
  components: {
    ConfirmUniformDialog,
    UniformEditDialog: () => import('@/modules/uniform/UniformEditDialog.vue'),
  },

  data() {
    return {
      headers: originHeaders,
      confirmDialog: false,
      search: '',
      tableOptions: {},
      editDialog: false,
      selectedItem: null,
      previewDialog: false,
      previewImages: [],
    }
  },

  async created() {
    await this.refresh()
  },

  methods: {
    ...mapActions('Uniformes', ['requestPageSettings', 'searchUniformList', 'removeUniform']),
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY, HH:mm')
    },

    async refresh(query) {
      query = query || {}

      this.searchUniformList(query)
    },

    onEdit(item) {
      this.editDialog = !this.editDialog

      this.selectedItem = item
    },

    onConfirmUniform(item) {
      this.confirmDialog = !this.confirmDialog
      this.selectedItem = item
    },

    onRemove(item) {
      this.$dialog.confirm({
        title: 'Thông báo xác nhận',

        text: 'Bạn có chắc muốn xóa đồng phục này? Bạn không thể hoàn tác hành động.',

        okText: 'OK',

        cancelText: 'Hủy',

        done: async () => {
          this.$loading.active = true

          try {
            await this.removeUniform(item._id)

            this.$alert.deleteSuccess()
          } catch (error) {
            this.$alert.deleteError(error)
          } finally {
            this.$loading.active = false
          }
        },
      })
    },

    openPreview(images, index) {
      this.previewImages = images

      this.previewDialog = true
    },
  },

  computed: {
    ...mapState('Uniformes', ['uniformes', 'totalItems', 'pageText', 'loading']),
  },

  watch: {
  },
}
</script>

<style lang="scss" scoped>
.center-icon >>> i {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.table-cell-wrapper {
  padding-top: 8px !important; /* Căn lề 8px */
  display: flex;
  align-items: flex-start; /* Căn theo top */
  justify-content: flex-start; /* Căn trái */
  height: 100%;
}

.images-wrapper {
  padding: 8px;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 8px;
  justify-self: left;
}

.image-preview {
  width: 60px;
  height: 60px;
}

.images-wrapper {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  cursor: pointer;
}

.image-preview {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
  transition: 0.3s ease;
}

.image-preview:hover {
  opacity: 0.8;
  transform: scale(1.05);
}

.carousel-image-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 500px; /* Chiều cao của carousel */
  background-color: #e0e0e0;
}

.carousel-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain; /* Giữ nguyên tỷ lệ, không bị cắt */
  border-radius: 4px;
}
.grey-background {
  background-color: #9a9b9d;
  border-radius: 4px;
}
</style>
